import useAxios from "utils/useAxios";

const BASE_URL = `/core/users/profile/`;

export const useClientProfileAPI = () => {

    const { api, nonCachedRequest } = useAxios();

    const fetch = (page = 1, page_size = 10, filters = [], callBack, errorCallBack) => {
        let url = BASE_URL + `?page_size=${page_size}&page=${page}`;
        filters.map((filter) => url += `&${filter.id.replace('.', '__')}__contains=${filter.value}`);
        nonCachedRequest(url, callBack, errorCallBack);
    };

    const update = (id, values, callBack, errorCallBack) => {
        api.put(BASE_URL + id + "/", values).then((response) => {
            callBack(response);
        }).catch((e) => {
            errorCallBack(e);
        })
    };

    const getClientRecords = (entityID, callBack, errorCallBack) => {
        const url = BASE_URL + (entityID ? `client_records/?entity_id=${entityID}` : "client_records/");

        api.get(url).then((response) => {
            callBack(response);
        }).catch((e) => {
            errorCallBack(e);
        })
    }

    const updateProfilePicture = (id, data) => {
        return api.patch(BASE_URL + id + "/update_profile_picture/", data)
    };

    const deleteProfilePicture = (id) => {
        return api.patch(BASE_URL + id + "/delete_profile_picture/")
    };

    const updateLanguage = (id, data) => {
        return api.patch(BASE_URL + id + "/update_language/", data)
    };

    const getSAFTFiles = (filters = [], page_size, page, sortColumns, callBack, errorCallBack) => {
        let url = BASE_URL + `saft_files/?page_size=${page_size}&page=${page}`;
        filters.map((filter) => {
            url += `&${filter.id.replace(/\./g, '__')}=${filter.value}`;
        });

        if (sortColumns) {
            url += `&ordering=${sortColumns}`
        }

        nonCachedRequest(url, callBack, errorCallBack);
    };

    return {
        fetch,
        update,
        updateProfilePicture,
        deleteProfilePicture,
        updateLanguage,
        getSAFTFiles,
        getClientRecords
    }
};

